import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const kreaModels: Record<string, TersaImageModel> = {
    'krea-v2-large': {
        chef: providers.krea,
        providers: [
            {
                ...providers.krea,
                model: wavespeed.image('wavespeed-ai/krea-v2-large/text-to-image'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.065 * COST_FACTOR;
                    return 0.06 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'krea-v2-medium': {
        chef: providers.krea,
        providers: [
            {
                ...providers.krea,
                model: wavespeed.image('wavespeed-ai/krea-v2-medium/text-to-image'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.035 * COST_FACTOR;
                    return 0.03 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'krea-v2-medium-turbo': {
        chef: providers.krea,
        providers: [
            {
                ...providers.krea,
                model: wavespeed.image('wavespeed-ai/krea-v2-medium-turbo/text-to-image'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.0175 * COST_FACTOR;
                    return 0.015 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['16x9', '9x16', '4x5', '4x3', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'krea-v2-turbo': {
        chef: providers.krea,
        providers: [
            {
                ...providers.krea,
                model: wavespeed.image('wavespeed-ai/krea-v2/turbo'),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = (providerOptions?.image_resolution || '').toUpperCase();
                    if (resolution === '2K') return 0.024 * COST_FACTOR;
                    return 0.012 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '21x9', '9x21', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '3x1', '1x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
            },
            i2i: {
                sizes: ['match', '16x9', '9x16', '21x9', '9x21', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '3x1', '1x3', '2x1', '1x2', '1x1'],
                resolutions: ['1K', '2K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};